/**
 * This class handles general modifications to ACF fields.
 *
 */
class generalACFModifications {
	constructor() {
		this.removeSeconds();
		this.restrictPastDates();
		this.validateFileSizes();
	}

	/**
	 * Rejects oversized files as soon as they are selected.
	 *
	 * ACF's basic uploader (shown to users without upload_files) has no client side
	 * validation, and a request over post_max_size is discarded by PHP along with
	 * everything else the user filled in. Clearing the input keeps it off the wire.
	 *
	 * The limit comes from the field's max_size, exposed as data attributes by
	 * Skolportalen_Forms::add_file_size_limit_data().
	 */
	validateFileSizes = () => {
		document.addEventListener( 'change', event => {
			const input = event.target;

			if ( ! input.matches || ! input.matches( 'input[type="file"]' ) ) {
				return;
			}

			const field = input.closest( '.acf-field[data-max-size-mb]' );

			if ( ! field ) {
				return;
			}

			this.clearFileSizeError( field );

			const maxMb = parseFloat( field.dataset.maxSizeMb );
			const file = input.files && input.files[ 0 ];

			if ( ! maxMb || ! file || file.size <= maxMb * 1024 * 1024 ) {
				return;
			}

			// Run in the capture phase and stop ACF's delegated change handler before
			// it can copy the oversized file's metadata into its hidden input.
			event.stopImmediatePropagation();
			input.value = '';

			const acfField = acf.getField( jQuery( field ) );
			const hidden = field.querySelector( 'input[type="hidden"][data-name="id"]' );

			if ( acfField ) {
				acfField.val( '' );
			} else if ( hidden ) {
				hidden.value = '';
			}

			const message = ( field.dataset.maxSizeMessage || '' )
				.replace( '{size}', this.formatFileSize( file.size ) )
				.replace( '{max}', `${ maxMb } MB` );

			this.showFileSizeError( field, message );
		}, true );
	};

	/**
	 * Displays an error message inside a file field.
	 *
	 * @param {HTMLElement} field   The ACF field wrapper.
	 * @param {string}      message The message to display.
	 */
	showFileSizeError = ( field, message ) => {
		const uploader = field.querySelector( '.acf-file-uploader' ) || field;
		const error = document.createElement( 'div' );
		const paragraph = document.createElement( 'p' );

		error.className = 'acf-error-message js-file-size-error';
		error.setAttribute( 'role', 'alert' );
		paragraph.textContent = message;
		error.appendChild( paragraph );

		uploader.prepend( error );
	};

	/**
	 * Removes any error message previously added to a file field.
	 *
	 * @param {HTMLElement} field The ACF field wrapper.
	 */
	clearFileSizeError = field => {
		field.querySelectorAll( '.js-file-size-error' ).forEach( error => error.remove() );
	};

	/**
	 * Formats a size in bytes for display.
	 *
	 * @param {number} bytes File size in bytes.
	 *
	 * @return {string} The formatted size.
	 */
	formatFileSize = bytes => {
		const megabytes = bytes / ( 1024 * 1024 );

		if ( megabytes < 1 ) {
			return `${ Math.round( bytes / 1024 ) } kB`;
		}

		return `${ megabytes.toFixed( 1 ) } MB`;
	};

	/**
	 * Removes the seconds from the datetime picker.
	 */
	removeSeconds = () => {
		acf.add_filter( 'date_time_picker_args', function( args, $field ) { // eslint-disable-line no-unused-vars
			args.units = [ 'hour', 'minute' ];
			args.showSecond = false;
			return args;
		} );
	};

	/**
	 * Restricts end date to dates after start date.
	 */
	restrictPastDates = () => {
		acf.add_filter( 'date_time_picker_args', function( args, field ) { // eslint-disable-line no-unused-vars
			const fieldKey = field[ 0 ].dataset.key;

			// Set restriction on start date.
			if ( fieldKey === 'field_639c42807ec90' ) {
				args.onSelect = function( date ) {
					// Set end date field min date.
					jQuery( ".af-field[data-key='field_639c43be7ec92'] .input" ).datepicker( 'option', 'minDate', date );
				};

				// Set up the maxDate for the start date field when opening it based on the value of the end date field if there is one.
				args.beforeShow = function( input, inst ) { // eslint-disable-line no-unused-vars
					const theDate = jQuery( ".af-field[data-key='field_639c43be7ec92'] .input" ).datepicker( 'getDate' );
					if ( theDate ) {
						const dateObject = new Date( theDate );
						return {
							maxDate: dateObject,
						};
					}
				};
			}

			// Set restriction on end date. Or more specifically, when the end date is selected, update the start dates datepicker with a new max date.
			if ( fieldKey === 'field_639c43be7ec92' ) {
				args.onSelect = function( date ) {
					// Set start date field max date.
					jQuery( ".af-field[data-key='field_639c42807ec90'] .input" ).datepicker( 'option', 'maxDate', date );
				};

				// Set up the minDate for the end date field when opening it based on the value of the start date field if there is one.
				args.beforeShow = function( input, inst ) { // eslint-disable-line no-unused-vars
					const theDate = jQuery( ".af-field[data-key='field_639c42807ec90'] .input" ).datepicker( 'getDate' );
					if ( theDate ) {
						const dateObject = new Date( theDate );
						return {
							minDate: dateObject,
						};
					}
				};
			}

			return args;
		} );
	};
}

export default generalACFModifications;
